'use client';

import React, { useEffect } from 'react';
import useUserStore from '@/lib/hooks/zustand-stores/use-user-store';
import useChatListStore from '@/lib/hooks/zustand-stores/use-chat-list-store';
import useAppsStore from '@/lib/hooks/zustand-stores/use-apps-store'

const AppStoreInitializer: React.FC = () => {
  const initializeWebsiteApps = useAppsStore(state => state.initializeWebsiteApps);
  const initializeChatApps = useAppsStore(state => state.initializeChatApps);

  const mixusUserId = useUserStore(state => state.user?._id);
  const mixusUserSettings = useUserStore(state => state.user?.settings);


  useEffect(() => {
    if (mixusUserId) {
      initializeWebsiteApps();
      initializeChatApps();
    }
  }, [mixusUserId, mixusUserSettings]);

  return null;
};

export default AppStoreInitializer;
